module.exports = __webpack_public_path__ + "static/media/delete.5c0313a9.svg";